import { IconLock, IconShieldCheck } from "@tabler/icons-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Alert, Button, Checkbox, Flex, Typography } from "antd";
import { useEffect, useState } from "react";
import { useArtemisAuth } from "@/auth/artemis-auth-provider";
import { AuthPageLayout } from "@/components/auth-layout";
import { CustomIcon } from "@/components/base";

export const Route = createFileRoute("/_public/login")({ component: Login });

function Login() {
	const { login, isLoading, isAuthenticated } = useArtemisAuth();
	const navigate = useNavigate();
	// Deliberately not persisted: terms must be re-accepted on every login.
	const [termsAccepted, setTermsAccepted] = useState(false);

	useEffect(() => {
		if (!isAuthenticated) return;
		// Back to the deep link that triggered login, if any; otherwise the slug-less
		// landing (/home resolves the org slug and forwards to /<slug>/workspaces).
		const returnTo = sessionStorage.getItem("returnTo");
		sessionStorage.removeItem("returnTo");
		navigate({ to: returnTo || "/home" });
	}, [isAuthenticated, navigate]);

	return (
		<AuthPageLayout>
			<Flex vertical align="center" gap={24}>
				<Flex vertical align="center" gap={6}>
					<Typography.Title
						level={3}
						style={{ margin: 0, textAlign: "center" }}
					>
						Welcome to StratoNext
					</Typography.Title>
					<Typography.Text type="secondary" style={{ textAlign: "center" }}>
						Sign in to access your enterprise portal
					</Typography.Text>
				</Flex>

				<Button
					type="primary"
					size="large"
					icon={<CustomIcon icon={IconLock} size={18} />}
					loading={isLoading}
					disabled={!termsAccepted}
					onClick={login}
					block
					style={{ height: 48, fontSize: 15, borderRadius: 8 }}
				>
					Log in to StratoNext
				</Button>

				<Checkbox
					checked={termsAccepted}
					onChange={(e) => setTermsAccepted(e.target.checked)}
				>
					<Typography.Text type="secondary" style={{ fontSize: 12 }}>
						By signing in, you agree to our{" "}
						<Typography.Link
							href="https://www.stratonext.ai/terms"
							target="_blank"
							rel="noreferrer"
							style={{ fontSize: 12 }}
						>
							Terms
						</Typography.Link>
						.
					</Typography.Text>
				</Checkbox>

				<Alert
					type="warning"
					title="Early Access version"
					description="Some features are not enabled yet and might not work as expected."
				/>

				<Flex align="center" gap={8} style={{ marginTop: 4 }}>
					<IconShieldCheck size={16} color="#8c8c8c" />
					<Typography.Text type="secondary" style={{ fontSize: 13 }}>
						Secure access for authorized users only
					</Typography.Text>
				</Flex>
			</Flex>
		</AuthPageLayout>
	);
}
